<template>
  <div class="account-cards__item">
    <div v-if="type">
      <div class="account__heading">
        {{ $t(`account.lms${type}.title`) }}
      </div>
      <div class="account-block">
        <span class="account__subtitle">{{ $t(`account.lms${type}.available${type}`) }}</span>
        <span class="account__text">{{ formatSubscription() }}</span>
      </div>
      <div class="account-block">
        <span v-show="expirationDate" class="account__subtitle">{{
          $t(`account.lms${type}.expirate${type}`)
        }}</span>
        <span v-if="expirationDate" class="account__text">
          {{ $t(`account.lmsCredits.endDateLabel`) }} {{ dateFormat() }}</span
        >
      </div>
      <div class="account__link">
        <router-link
          v-profile-guard="`components.plan.credits.edit.seeRecords`"
          :to="{ name: 'client-credits-record' }"
          exact
        >
          {{ $t(`actions.seeRecord`) }}</router-link
        >
        <router-link
          v-if="type === 'Credits'"
          v-profile-guard="`components.plan.credits.edit.manageCredits`"
          :to="{ name: 'credits-record' }"
          exact
        >
          {{ $t(`actions.manageCredits`) }}</router-link
        >
        <router-link
          v-if="type === 'Credits'"
          v-profile-guard="`components.plan.credits.edit.buyCredits`"
          :to="{ name: 'buy-credits' }"
          exact
        >
          {{ $t(`actions.buy${type}`) }}</router-link
        >
        <router-link
          v-else
          v-profile-guard="`components.plan.subscription.edit.manageSubscription`"
          :to="{ name: 'subscription-record' }"
          exact
        >
          {{ $t(`actions.manageSubscription`) }}</router-link
        >
      </div>
    </div>
    <div v-else>
      <div class="account__heading">
        {{ $t('account.lmsUsers.title') }}
      </div>
      <div class="account-block">
        <span class="account__text">{{ $t('account.lmsUsers.notAvailable') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import utils from '@/utils/functions.js';

export default {
  name: 'CardSubscription',
  computed: {
    ...mapState({
      subscriptionTotal: (state) => state.subscriptions.total,
      expirationDate: (state) => state.subscriptions.expirationDate,
      type: (state) => state.subscriptions.type,
      userData: (state) => state.profile.profileData
    })
  },
  methods: {
    formatSubscription() {
      const val = this.subscriptionTotal;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    dateFormat() {
      return utils.formatDate(this.userData.lang, this.expirationDate);
    }
  }
};
</script>
